import { Product } from 'types/entity/product';

export const getProductsWithMatchingVariants = (products: Product[], skus: string[]): Product[] => {
  return products
    .map((product) => ({
      ...product,
      variants: product.variants.filter((variant) => skus.includes(variant.sku)),
    }))
    .filter((product) => product.variants.length > 0);
};
